const actions = {
  SET_STATE: 'photobooth/SET_STATE',
  PHOTOBOOTH_ANALYTICS: 'photobooth/PHOTOBOOTH_ANALYTICS',
  UPLOAD_PHOTOBOOTH_IMAGE: 'photobooth/UPLOAD_PHOTOBOOTH_IMAGE',
  FETCH_PHOTOBOOTH_ENTERIES: 'photobooth/FETCH_PHOTOBOOTH_ENTERIES'
}

export default actions
